<template>
    <div class='container'>
        <div class="shopping_instructions">
            <div class="instructions" v-for="item in getfooter" :id=item.name v-if="item.name!=='關於' && item.name!=='防诈骗公告'&& item.name!=='隱私權條款'&& item.name!=='消費者權益'&& item.name!=='會員服務條款'">
                <div class="title">{{item.name}}</div>
                <div class="line"></div>
                <div v-html="item.content"></div>
            </div> 
        </div>
    </div>
</template>
<script>
// import $ from 'jquery'
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            data:[],
            webmeta: {
                og_title: '',
                illustrate_title: '',
                illustrate_description:''
            }
        };
    },
    computed: {
        // ...mapState
        ...mapState('header', ['getfooter', 'cate', 'website', 'getnav', 'seo']),
        computedOgTitle() {
            return this.seo.og_title || '';
        },
        computedTitle() {
            return this.seo.illustrate_title || '';
        },
        computedDescription(){
            return this.seo.illustrate_description || '';
        }
    },
    metaInfo() {
        return {
            title: this.webmeta.illustrate_title || this.webmeta.og_title,
            meta: [
                { vmid: 'description', name: 'description', content: this.webmeta.illustrate_description },
            ]
        }
    },
    watch: {},
    methods: {
        toLocal() {
            //查找存储的锚点id
            let Id = localStorage.getItem('toId');
            let toElement = document.getElementById(Id);
            //锚点存在跳转
            if (Id) {
                toElement.scrollIntoView(true)
            }
        }
    },
    created() {
        this.webmeta.og_title = this.computedOgTitle;
        this.webmeta.about_title = this.computedTitle;
        this.webmeta.about_description = this.computedDescription;
    },
    mounted() {
        for (const key in this.getfooter) {
            if (this.getfooter[key].name !== "關於") {
                this.data.push(this.getfooter[key])
            }
            // console.log(this.getfooter[key]);
        }
        // this.$nextTick(() => { this.toLocal() })
        // let _this = this;
        // _this.$nextTick(function () {
        //     window.addEventListener('scroll', _this.handleScroll)
        // });
        // $('#navbar-nav')[0].childNodes.forEach(element => {
        //     $(element).removeClass('active')
        //     if (element.childNodes[0].childNodes[0].innerText == this.$route.params.name) {
        //         $(element).addClass('active')
        //     }
        // });
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>
<style lang="scss" scoped>

p {
    margin: 0 !important;
}
img{
    display: block;
}
</style>